import { FC, PropsWithChildren, ReactElement } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { ISearchFallbackBoundary } from './types';

const useFallback = ({
  EmptyQueryFallback,
  NoResultsFallback
}: Pick<ISearchFallbackBoundary, 'EmptyQueryFallback' | 'NoResultsFallback'>): ReactElement | null => {
  const { indexUiState, results } = useInstantSearch();

  // Check if there is no query
  if (!indexUiState.query) {
    return <EmptyQueryFallback />;
  }

  // Check if there are no hits
  // eslint-disable-next-line no-underscore-dangle
  if (!results.__isArtificial && results.nbHits === 0) {
    return <NoResultsFallback query={indexUiState.query} />;
  }

  return null;
};

export const SearchFallbackBoundary: FC<PropsWithChildren<ISearchFallbackBoundary>> = ({ children, ...components }) => {
  const fallback = useFallback(components);

  if (fallback) {
    return (
      <>
        {fallback}
        <div hidden>{children}</div>
      </>
    );
  }

  return <>{children}</>;
};

SearchFallbackBoundary.displayName = 'SearchFallbackBoundary';
